import { Stack } from '@mui/material'
import { useAvailableFeatures, useCompanyInfo } from 'hooks/company'
import { useContacts } from 'hooks/contact'
import { useProgramsForTop } from 'hooks/program'
import Contact from './Contact'
import Feedback from './Feedback'
import MediaSeminar from './MediaSeminar'
import Post from './Post'
import PRAnalysis from './PRAnalysis'
import Program from './Program'
import Research from './Research'


const TopMobile = () => {
    const { data : company } = useCompanyInfo()
    const { data : features } = useAvailableFeatures()
    const { data : program } = useProgramsForTop()
    const contacts = useContacts()

    const on = company && !company.ツナグープラス


    return (
        <Stack
            gap={1.5}
        >
            {features?.広報活動診断 &&
            <PRAnalysis />
            }
            {features?.プログラム申込 && !!Object.keys(program || {}).length &&
            <Program />
            }
            {on && contacts &&
            <Contact />
            }
            {on && company?.セミナー機能 &&
            <MediaSeminar />
            }
            {on &&
            <Post />
            }
            {on && features?.フィードバック &&
            <Feedback />
            }
            {features?.リサーチ &&
            <Research />
            }
        </Stack>
    )
}

export default TopMobile
